// vconsole开关
const VITE_ENABLE_VCONSOLE = import.meta.env.VITE_ENABLE_VCONSOLE
class VConsolePlugin {
  static install(app) {
    // 开发环境默认开启，生产环境通过 URL 参数开启
    const shouldEnable =
      VITE_ENABLE_VCONSOLE === 'true' ||
      new URLSearchParams(window.location.search).get('vconsole') === '1'

    if (shouldEnable) {
      import('vconsole').then(({ default: VConsole }) => {
        const vConsole = new VConsole({
          theme: 'dark', // 可选主题: 'light'|'dark'
          onReady: () => console.log('VConsole is ready'),
        })
      })
    }
  }
}

export default VConsolePlugin
